import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Card';
import {priceList} from './priceList';

import Toggler from "../Toggler";

class CardWrapper extends React.Component {
  state = {
    cardList: priceList,
    period: 'year'
  };

  handleTogglerChange = (checked) => {
    this.setState({
      period: checked ? 'month' : 'year'
    });
  };

  render() {
    const {currentPlan, context, qs, hasLightBg} = this.props;
    let currentCard = {};
    for (let i = 0; i < priceList.length; i++) {
      if (priceList[i].plan === currentPlan) {
        currentCard = priceList[i];
      }
    }

    return (
      <div>
        <div className="cardWrapperSelect">
          <Toggler firstLabel="Maand" secondLabel="Jaar (-5%)" inversed={!hasLightBg} center onChange={this.handleTogglerChange}/>
        </div>
        <div className="cardWrapper">
          {this.state.cardList.map((card, index) => {
            return (
              <Card key={index}
                    plan={card.plan}
                    disabled={card.weight === currentCard.weight}
                    currentPlan={currentPlan}
                    context={context}
                    qs={qs}
                    cardLight={hasLightBg}
                    headerTitle={card.headerTitle}
                    showPeriod={this.state.period}
                    priceMonth={card.price.month}
                    priceYear={card.price.year}
                    cardHighlight={card.cardHighLight}
                    cardContentList={card.cardContentList}
                    priceMonthYear={card.price.monthYear}/>
            );
          })}
          <p>Alle genoemde prijzen zijn exclusief 21% BTW</p>
        </div>
      </div>
    );
  }
}

CardWrapper.propTypes = {
  currentPlan: PropTypes.string,
  hasLightBg: PropTypes.bool,
  context: PropTypes.string,
  qs: PropTypes.string,
};

export default CardWrapper;
